module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_hoffman_sm-5d92ad1c88c5ff9b5b9283383568e8e6.png";